import React from 'react';
import { RecallsApiResponse } from '../../../services/recalls-service/recalls-service';
import AccordionItem from '../../components/AccordionItem/AccordionItem';
import { RecallsProps } from '../recalls/hook/use-recalls-content';
import warningSVG from '../../../assets/recalls-warning.svg';
import { ExemptWordsListProps } from '../recalls/hook/use-exempt-word-list';
import { TABLET_BREAKPOINT } from '../../support-constants';
import { recallsToLowerCase } from '../../components/recalls-button/recalls-button';
const CspAccordion = (
    exemptWordsContent: ExemptWordsListProps | null,
    recallData: RecallsApiResponse | undefined | null,
    recallsContent: RecallsProps,
    isWebview: boolean,
    isYmm: boolean,
    isLincoln: boolean
) => {
    return (
        <>
            {(recallsContent.detailsCspShortLabel ||
                recallsContent.detailsCspLabel) &&
            recallData?.cspCount &&
            recallData?.cspCount > 0 ? (
                <div className="csp-section" id="csp-section">
                    <div className="section-heading-link" id="csp" />
                    <div className="recalls-section-heading">
                        <img
                            height={24}
                            width={24}
                            src={warningSVG}
                            alt=""
                            className="recall-warning-icon"
                            loading="lazy"
                        />
                        <h2>
                            {window.innerWidth <= TABLET_BREAKPOINT
                                ? recallsContent.detailsCspShortLabel
                                : recallsContent.detailsCspLabel}
                        </h2>
                    </div>
                    <div className="support-accordion">
                        {recallData?.fsa?.map(csp => (
                            <AccordionItem
                                title={recallsToLowerCase(
                                    csp.descriptionLang,
                                    exemptWordsContent
                                )}
                                id={csp.fsaNumber}
                                key={csp.descriptionLang}
                            >
                                <div className="support-accordion-description-label">
                                    {
                                        recallsContent?.detailsAccordionDescriptionLabel
                                    }
                                </div>
                                <div className="support-accordion-description-content">
                                    {recallsToLowerCase(
                                        csp.descriptionLang,
                                        exemptWordsContent
                                    )}
                                </div>
                                <div className="support-accordion-description-label">
                                    {recallsContent?.detailsCampaignNumberLabel}
                                </div>
                                <div className="support-accordion-description-content">
                                    {csp.fsaNumber}
                                </div>
                                {recallsContent?.detailsNextStepsLabel &&
                                    !isYmm &&
                                    !isLincoln &&
                                    !isWebview && (
                                        <>
                                            <div className="support-accordion-description-label">
                                                {
                                                    recallsContent?.detailsNextStepsLabel
                                                }
                                            </div>
                                            <div className="support-accordion-description-content">
                                                {
                                                    recallsContent?.detailsNextStepsCSP
                                                }
                                            </div>
                                        </>
                                    )}
                            </AccordionItem>
                        ))}
                    </div>
                </div>
            ) : (
                recallData &&
                (recallsContent.detailsNoCspShortLabel ||
                    recallsContent.detailsNoCspLabel) && (
                    <div className="csp-section">
                        <div className="section-heading-link" id="csp" />

                        <div className="recalls-section-heading">
                            <img
                                src={
                                    process.env.REACT_APP_AEM_BASE_URL +
                                    recallsContent.greenCheckMark
                                }
                                alt=""
                                loading="lazy"
                                height={24}
                                width={24}
                            />
                            <h2>
                                {window.innerWidth <= TABLET_BREAKPOINT
                                    ? recallsContent.detailsNoCspShortLabel
                                    : recallsContent.detailsNoCspLabel}
                            </h2>
                        </div>
                        {recallsContent.detailsNoCspDescription && (
                            <div className="recalls-no-action-needed-description">
                                {recallsContent.detailsNoCspDescription}
                            </div>
                        )}
                    </div>
                )
            )}
        </>
    );
};

export default CspAccordion;
